import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';
import TrackingComponent from '../components/TrackingComponent';
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";


export default class AddToCartComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart',
      error: '.js-addtocart-notification',
      container: '.js-form-container',
      giftcard: '.js-addtocart-giftcard',
      submitNotifyBtn: '.js-submit',
      addtowish: '.js-addremove-wishlist a',
      btnSize: '.c-s-r__size',
      miniCart: '.js-minicart',
      quickCart: '.l-quick-cart',
      quickCartWrapper: '.c-m-h__actions__desk-mini-cart.action--quickcart',
      popupWrapper:'.l-q-c__wrapper',
      dataQty: '[data-mcqty]',
      mobileMinicartBtn: '.c-m-h__actions__mini-cart .icon-box',
      sizesForm: '.c-pdp-sizes'
    };
  }

  get CLASSES() {
    return {
      visible: 'show',
      visibleQuickCartMobile: 'show-popup-mobile',
      positionPopupCartMobile: 'position-popup-mobile',
      hideQty: 'hideQty',
      addingClass: 'adding',
      addedClass: 'added',
    };
  }

  get FORM_RESULT_STATUSES(){
    return {
      ok: 'OK',
      error: 'error'
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.mainTarget = $(this.SELECTORS.main);
    this.error = $(this.SELECTORS.error);
    this.container = $(this.SELECTORS.container);
    this.giftcard = $(this.SELECTORS.giftcard);
    this.submitNotifyBtn = $(this.SELECTORS.submitNotifyBtn);
    this.updateMiniCartBtn = $(this.SELECTORS.miniCart);
    this.quickCart = $(this.SELECTORS.quickCart);
    this.quickCartWrapper = $(this.SELECTORS.quickCartWrapper);
    this.popupWrapper = $(this.SELECTORS.popupWrapper);
    this.mobileMinicartBtn = $(this.SELECTORS.mobileMinicartBtn);
    this.TrackingComponent = new TrackingComponent();
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
  }

  openMinicart(elem) {

    const isGiftcard = elem === 'giftcard';
    let ctx = this;
    let productCode;
    let button;

    if (isGiftcard) {
      return ctx.openMinicartGiftcard();
    }
    button = elem || ctx.mainTarget;
    productCode = ctx.selectedSize(button);
    let $elem = ctx.updateMiniCartBtn;

    return doAjax({
      url: $elem.data('link'),
      data: {
        'productCode': productCode
      },
      dataType: "html",
      type: 'POST',
      success: function (resp) {
        ctx.openMinicartSuccess(resp);
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  openMinicartGiftcard() {
    let ctx = this;
    let $elem = ctx.updateMiniCartBtn;

    return doAjax({
      url: $elem.data('giftcard-link'),
      dataType: "html",
      success: function (resp) {
        ctx.openMinicartSuccess(resp);
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  openMinicartSuccess(resp) {
    let ctx = this;
    let $replace = ctx.quickCart;
    ctx.log('Open Minicart...');
    let response = new DOMParser().parseFromString(resp, 'text/html');
    $(response).find('.icon-close').remove();
    $(response).find('.l-q-c__checkout__detail').remove();
    $(response).find('.l-q-c__checkout__note').remove();
    $(response).find('.l-q-c__checkout').css('background-color', '#FFFFFF');
    $replace.html(response.querySelector('.l-quick-cart').innerHTML);
    $replace.removeClass('empty');
    // update cart counter
    ctx.updateQty();
    clearTimeout(this.timeout);
    ctx.quickCart.find('.l-q-c__title').attr("data-mcqty","");
    ctx.quickCart.find('.l-q-c__title').addClass(ctx.CLASSES.hideQty);
    ctx.quickCartWrapper.addClass(ctx.CLASSES.visible);
    ctx.quickCartWrapper.addClass(ctx.CLASSES.visibleQuickCartMobile);
    setTimeout(() => {
      ctx.quickCartWrapper.removeClass(ctx.CLASSES.visible);
      ctx.quickCartWrapper.removeClass(ctx.CLASSES.visibleQuickCartMobile);
      ctx.updateMinicart();
    }, 2000);
  }

  selectedSize(target) {
    const ctx = this;
    const parent = $(target).parent().parent();
    let sizeSelected;
    let sizes = parent.siblings(ctx.SELECTORS.sizesForm)[0];
    if (typeof sizes === 'undefined') {
      sizes = parent.parent().siblings(ctx.SELECTORS.sizesForm)[0];
    }
    if ($(sizes).find('.c-pdp-s__select-size').length !== 0) {
      sizeSelected = $(sizes).find(".c-pdp-s__item.selected").data("productCode");
    } else {
      sizeSelected = $(target).data('code');
    }
    return sizeSelected;
  }

  cleaningSelectedSize($elem){
    let productCode = $elem[0].dataset.code;
    let notification = $elem[0].dataset.notification;
    let sizeWrapper = $('[data-sizes-trigger='+productCode+']');
    let sizeWrapperSelected = $('[data-sizes-trigger=prod-'+productCode+'] [data-size-selected]');
    // reset label
    if ( typeof sizeWrapperSelected !== 'undefined' && sizeWrapperSelected.length > 0 ) {
      sizeWrapperSelected.html(notification);
    }
    //
    $(".c-pdp-s__item").each(function(){
      if (!$(this).hasClass('hidden')) {
      if(this.getAttribute("data-product-code").includes(productCode)){
          $(this).removeClass("selected");
        }
      }
    });
  }

  updateMinicart() {
    let ctx = this;
    let $elem = ctx.updateMiniCartBtn;
    let $replace = ctx.quickCart;

    return doAjax({
      url: $elem.data('url'),
      dataType: "html",
      success: function (resp) {
        ctx.log('Minicart updated...');
        let response = new DOMParser().parseFromString(resp, 'text/html');
        $replace.html(response.querySelector('.l-quick-cart').innerHTML);
        $replace.removeClass('empty');
        // update cart counter
        ctx.updateQty();
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  updateQty() {
    let qty = this.quickCart.find('.l-q-c__title').data('mcqty');
    // desktop
    if (this.updateMiniCartBtn != null) {
      this.updateMiniCartBtn.find('.icon-box__dot').attr("data-mcqty",qty);
    }
    // mobile
    if (this.mobileMinicartBtn != null) {
      this.mobileMinicartBtn.find('.icon-box__dot').html(qty);
    }
  }

  bindEvents() {
    // global
    let ctx = this;
    // click on addtocart
    $('body').on('click.addToCart', ctx.SELECTORS.main, function (e) {
      e.preventDefault();
      //
      let $this = $(this);
      let sendRequest =  ctx.selectedSize($this);

      ctx.log(' sendRequest ',sendRequest);
      // check if is size selected
      if (typeof sendRequest == 'undefined') {
        ctx.log("Select a size");
        // emit size required event
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, {size: $this, isMobileLook: $this.closest('.cyo__mobile').length != 0});
      } else {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtocart, {button: $this});
        ctx.TrackingComponent.actions.addToCart(sendRequest);
      }
    });

    //click on addtocart giftcard
    $('body').on('click.addToCartGiftcard', ctx.SELECTORS.giftcard, function (e) {
      e.preventDefault();
      let $this = $(this);
      var form = $this.closest('form');
      var elemData = form.serialize();
      var trackData = {'formId': form.prop('id')};
      ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
        button: $this,
      })
      $this.attr("disabled", true);
      doAjax({
        type: "post",
        url: form.attr('action'),
        data: elemData,
        contentType: "application/x-www-form-urlencoded",
        success: function (responseData, textStatus, jqXHR) {
          // replace all form html
          form.html(responseData);
          // emit events
          ctx.$emit(ctx.$customEvents.PAGE_LAYOUT_EVENTS.changed);
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {button: $this});
          // reset privacy - i need to do it on error or not
          if (form.find('#gcTerms').length > 0 ) form.find('#gcTerms').prop('checked', false);
          // check if there are errors and show minicart notification
          var formResultStatus = ctx.getFormResultStatus(responseData);
          if(ctx.FORM_RESULT_STATUSES.ok == formResultStatus){
            // if it's a go
            ctx.openMinicart('giftcard');
            if ($('#giftcardAddedAmount') != null && $('#giftcardAddedAmount').val() != null ) {
              ctx.TrackingComponent.actions.addCartGiftCard($('#giftcardAddedAmount').val());
            }
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, {button: $this});
          }
          if (responseData.indexOf('error') > 1 ){
            window.scrollTo(0,0);
            return;
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $this.attr("disabled", false);
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {button: $this});
        }
      })

    });

    // Add To Cart
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({event, payload}) => {
      // vars
      let $elem = $(payload.button);
      const addToCartLabel = payload.button[0].dataset.labelCartAdded;
      const addToCartErrorLabel = payload.button[0].dataset.labelCartError;
      $elem.data('code',this.selectedSize($elem));
      this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
        button: $elem,
      })
      $elem.attr("disabled", true);
      // ajax call
      doAjax({
        url: $elem.data('href'),
        data: $elem.data(),
        dataType: "html",
        success: function (response) {
          if (response == 650) {
            var remoteHref = $elem.data('exceeded-cart-qty');
            if (!isNaN($elem.data('product-code'))) {
              remoteHref = remoteHref + $elem.data('product-code');
            } else if (!isNaN($elem.data('base-code'))) {
              remoteHref = remoteHref + $elem.data('base-code');
            } else {
              remoteHref = remoteHref + $elem.data('code');
            }
            $elem.removeClass(ctx.CLASSES.addingClass).removeClass(ctx.CLASSES.addedClass);
            doAjax({
              url: remoteHref,
              dataType: "html",
              success: function (html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'exceeded-cart-products'
                })
                ctx.liveRegion.sayMessage(addToCartErrorLabel);
                console.info("[AddToCart] Exceed product max number on cart.")
              },
              error: function (xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
                ctx.liveRegion.sayMessage(addToCartErrorLabel);
              }
            });

          } else if (response == 651) {
              let remoteHref = $elem.data('lowstock-cart-qty');
              let productCode = $elem.data('code');
              let baseCode = $elem.data('base-code');
              if (!isNaN(productCode)) {
                remoteHref = remoteHref + productCode;
              } else if (!isNaN(baseCode)) {
                remoteHref = remoteHref + baseCode;
              } else {
                remoteHref = remoteHref + $elem.data('product-code');
              }
              $elem.removeClass(ctx.CLASSES.addingClass).removeClass(ctx.CLASSES.addedClass);
              doAjax({
                url: remoteHref,
                dataType: "html",
                success: function (html) {
                  $elem.attr("disabled", false);
                  ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                    unsafeContent: html,
                    modalClass: 'exceeded-cart-products'
                  })
                  console.info("[AddToCart] Lowstock product number on cart.")
                  ctx.liveRegion.sayMessage(addToCartErrorLabel);
                },
                error: function (xhr) {
                  $elem.attr("disabled", false);
                  console.error("[AddToCart]", xhr, arguments);
                  ctx.liveRegion.sayMessage(addToCartErrorLabel);
                }
              });
            } else {
            // success
            $elem.attr("disabled", false);
            let inWishlistLayer = payload.inWishlistLayer;
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, {
              button: $elem,
              inWishlistLayer: inWishlistLayer
            });
            ctx.liveRegion.sayMessage(addToCartLabel);
          }
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {button: $elem});
          ctx.$emit(ctx.$customEvents.SIZES_EVENTS.sizesclose, {layer: $('.js-sizes')});
          //ctx.updateMinicart();
          ctx.openMinicart($elem);
          ctx.cleaningSelectedSize($elem);
          ctx.$emit(ctx.$customEvents.MENU_EVENTS.hideMenu, {time: 3000}, '.action--quickcart');
        },
        error: function (xhr) {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {button: $elem})
          ctx.liveRegion.sayMessage(addToCartErrorLabel);
          // on error i check the status
          if (xhr.status == '510') {
            // url for availability
            var remoteHref = ctx.mainTarget.data('remote-unavailable') + $elem.data('code');
            // ajax call
            doAjax({
              url: remoteHref,
              dataType: "html",
              success: function (html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, { unsafeContent: html, modalClass: 'unavailable-product', type: 'product-unavailable' })
              },
              error: function (xhr) {
                $elem.attr("disabled", false);
                ctx.error.html('Error in addtocart');
                console.error("[AddToCart]", xhr, arguments);
              }
            });
          } else {
            $elem.attr("disabled", false);
            //ctx.error.html(xhr.responseText);
            ctx.error.html('Error in addtocart');
            console.error("[AddToCart]", xhr, arguments);
          }
        }
      });

    });


    // animation part
    // adding class
    this.$on(this.$customEvents.LOADER_EVENTS.showLocal, ({event, payload}) => {
      payload.button.addClass(this.CLASSES.addingClass);
    });

    // added class
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({event, payload}) => {
      let ctx = this;
      payload.button.addClass(ctx.CLASSES.addedClass);
      // and remove after 1,5 sec
      setTimeout(function(){
        payload.button.removeClass(ctx.CLASSES.addingClass).removeClass(ctx.CLASSES.addedClass);
      },1500);
    });

  }

  checkGcTerms(_this) {
    if ($("[name='gcTerms']").is(":checked")) {
      $(_this.SELECTORS.giftcard).attr('disabled', false);
    } else {
      $(_this.SELECTORS.giftcard).attr('disabled', true);
    }
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    this.checkGcTerms(this);
    let _this = this;
    $("body").on("change", "[name='gcTerms']", function () {
      _this.checkGcTerms(_this);
    });
  }

  getFormResultStatus(htmlForm){
    var match = htmlForm.match("data-result=\"(" + this.FORM_RESULT_STATUSES.ok + "|" + this.FORM_RESULT_STATUSES.error + ")\"");
    return match[1];
  }

}
